import { render } from "./NavContainer.vue?vue&type=template&id=0fa6d4ee&scoped=true"
import script from "./NavContainer.vue?vue&type=script&lang=js"
export * from "./NavContainer.vue?vue&type=script&lang=js"

import "./NavContainer.vue?vue&type=style&index=0&id=0fa6d4ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa6d4ee"]])

export default __exports__